module.exports = __webpack_public_path__ + "img/founder2.8dbf3f09.png";